import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
  function LabResultEntrySaved(props) {
    const {lab_id, ltestid} = useParams();

    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [labData,setlabData] = useState([]);
    const [labtestData,setLabTestData] = useState([]);
    const [labbillData, setLabBillData] = useState([]);
    const [lres, setLres] = useState();
    const [labv, setLabv] = useState({});
    const [changed, setChanged] = useState(false);
    const [patData, setPat] = useState();
    const [age, setAge] = useState();
    const [gender, setGender] = useState();


    const handleChange = (event) => {
      const inputName = event.target.name;
      const inputValue = event.target.value;

      if (inputName === 'patient') {
        setPat(inputValue);
      } else if (inputName === 'age') {
        setAge(inputValue);
      } else if (inputName === 'gender') {
        setGender(inputValue);
      }
    };

    useEffect(() => {
      const fetchData = async () => {
      try {
        const response1 = await axios.get(baseUrl+'lab-test-view-saved/'+lab_id+'/'+ltestid+'/');
        setLabTestData(response1.data);
        setLres(response1.data[0].results.split(','));
        setLabv(response1.data[0].abnormal_status.split(','));

        const response2 = await axios.get(baseUrl+'lab-test-view/'+ltestid+'/');
        setLabBillData(response2.data);

        const response3 = await axios.get(baseUrl+'lab-pay/'+lab_id)
        setlabData(response3.data);
        setPat(response3.data[0].pat.patient);
        setAge(response3.data[0].pat.age);
        setGender(response3.data[0].pat.gender);

      } catch (error) {
        console.log(error);
      }
    };
      fetchData();
    }, []);


  useEffect(() => {
    const textarea = document.querySelector('textarea.no-comma');
    if (!textarea) {
      return;
    }
    function handleKeyDown(e) {
      if (e.keyCode === 188 || e.keyCode === 222) {
        e.preventDefault();
      }
    }

    function handleChangeInput() {
      textarea.value = textarea.value.replace(/,/g, '');
    }

    textarea.addEventListener('keydown', handleKeyDown);
    textarea.addEventListener('change', handleChangeInput);
    textarea.addEventListener('input', handleChangeInput);

    function handleKeyPress(e) {
      const ignoreKeyCodes = [34, 39];

      if (ignoreKeyCodes.includes(e.which)) {
        e.preventDefault();
        document.querySelector('.error').innerHTML = 'only valid characters are allowed';
        document.querySelector('.error').style.display = 'block';
      } else {
        document.querySelector('.error').style.display = 'none';
      }
    }
    document.addEventListener('keypress', handleKeyPress);

    return () => {
      textarea.removeEventListener('keydown', handleKeyDown);
      textarea.removeEventListener('change', handleChangeInput);
      textarea.removeEventListener('input', handleChangeInput);
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, []);

    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

    function handleSubmit(event) {
    event.preventDefault();
      let results = '';
      let abValueString = '';
      let billIndex = 0;
      const formData = new FormData();
      if (labtestData.length > 0) {
        billIndex = 0;
      }
      for (let i = 0; i < labbillData.length; i++) {
        const abValue = labv[`abValue_${i}`] ? "1" : "0";
        abValueString += abValue + ',';
      }
    abValueString = abValueString.slice(0, -1);
    const sampleDate = document.getElementById("sampleDate").value;
    const patient = document.getElementById("patient").value;
    const gender = document.getElementById("gender").value;
    const age = document.getElementById("age").value;
    const pat_id = document.getElementById("pat_id").value;
    const textareaList = document.querySelectorAll('textarea.no-comma');
    textareaList.forEach(textarea => {
      results += textarea.value + ',';
    });
    results = results.slice(0, -1);
    formData.append('patient', patient);
    formData.append('gender', gender);
    formData.append('age', age);
    formData.append('results', results);
    formData.append('abnormal_status', abValueString);
    formData.append('sample_date', sampleDate);
    formData.append('pat_id', pat_id);
    axios.post(baseUrl+'update-lab-test/'+labtestData[billIndex].id+'/',  formData, {
                  headers : {
                    'content-type': 'multiple/form-data'
                }
            })
      .then(response => {
        if(response.status==200 || response.status==201){
                console.log(response.data)
                Swal.fire({
                  title: 'Edited Successfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                  setTimeout(() => {
                  window.location.href = ('/lab-result-view/');
                }, 3000);
              }
              })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed to add lab entry. Please try again later.',
                'error'
              );
            });
  };

    const handleValueChange = (event) => {
    const newResult = event.target.value;
    const newAbv = { [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value };
      setLres(newResult);
      setLabv(newAbv);
    };



    return (
        <section>
         <form onSubmit={handleSubmit}>
          <div >
              {labData.map((row, index) =>
                <div className="table-responsive">
                <table border="2"  className="text-justify mt-4" width="100%" >
                  <tr style={{borderColor: "#F2F2F2"}}>
                   <th className="mx-0 ps-5" rowSpan="10">
                   <input type="hidden" name="pat_id" id="pat_id" value={row.pat.id} />
                   <input type="hidden" name="cons_id" id="cons_id" value={row.cons.id} />
                        Name : <input type="text" name="patient" id="patient" value={patData}
                                onChange={handleChange}
                         /><br></br>
                        PID : {row.pat.pat_id}<br></br>
                        Consultant : Dr.{row.cons.consultant}
                   </th>
                   </tr>
                   <tr style={{borderColor: "#F2F2F2"}}>
                   <th>
                        Gender : <input type="text" name="gender" id="gender" value={gender}
                                onChange={handleChange}
                         /><br></br>
                        Age : <input type="text" name="age" id="age" value={age}
                                 onChange={handleChange} /><br></br>
                        Sample Date : {labtestData[0].sample_date}
                        <DatePicker name="sampleDate" id="sampleDate" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
                   </th>
                   </tr>
                </table>
              </div>
              )}
              <div className="table-responsive">
                <table className="table table-bordered mt-4">
                  <thead>
                    <tr style={{borderColor: "#F2F2F2"}}>
                       <th align="left">Sample Type</th>
                       <th align="left">Test</th>
                       <th align="left">Results</th>
                       <th align="left">Abnormal</th>
                       <th align="left">Units</th>
                       <th align="left">Ranges</th>
                       <th align="left">Method</th>
                    </tr>
                  </thead>
                  <tbody>
                  {labbillData.map((lab, billIndex) => (
                    <tr key={billIndex}>
                      <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.sample}</td>
                      <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.test}</td>
                      {labtestData.map((test, testIndex) => {
                        const results = test.results.split(',').map(res => res.trim());
                        const abValue = test.abnormal_status.split(',').map(ab => ab.trim());
                        return (
                          <React.Fragment key={testIndex}>
                          <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                          <textarea
                            className="no-comma"
                            tabIndex="0"
                            name={`result_${testIndex}_${billIndex}`}
                            id={`result_${testIndex}_${billIndex}`}
                            value={lres[billIndex]}
                            onChange={(e) => {
                              setChanged(true);
                              setLres({
                                ...lres,
                                [billIndex]: e.target.value,
                              });
                            }}
                            required
                          />
                          </td>
                          <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                          <input
                            className="form-check-input"
                            tabIndex="-1"
                            type="checkbox"
                            name={`abValue_${testIndex}_${billIndex}`}
                            id={`abValue_${testIndex}_${billIndex}`}
                            value={labv[`abValue_${billIndex}`] ? "1" : "0"}


                            onChange={(e) => {
                                console.log({[`abValue_${e.target.id.split('_')[1]}`]: e.target.checked})
                              setChanged(true);
                              setLabv(prevState => ({
                              ...prevState,
                              [billIndex]: {
                                ...prevState[billIndex],
                                [`abValue_${e.target.id.split('_')[1]}`]: e.target.checked
                              }
                            }));

                            }}

                           />
                           </td>
                          </React.Fragment>
                        );
                      })}
                      <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.units}</td>
                      <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.ranges}</td>
                      <td style={{border: "1px solid", borderColor: "#2194d9"}}>{lab.method}</td>
                    </tr>
                  ))}
                </tbody>
                </table>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button type="submit" className="btn btn-primary mt-4">
                         Submit</button>
            </div>
            </form>
        </section>
    );
  }
export default LabResultEntrySaved;